import { fetchFromOldApi } from '~/services/Http';

export type PasswordData = {
  fLoginPassword: string;
  fLoginNewPassword: string;
};

export type IFormInput = {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
};

export type PasswordChangeResponse = {
  fLoginSuccess: boolean;
  fLoginUserName: string;
  fLoginPwChangeSuccess?: boolean;
  fLoginPwChangeFailureReason?: string;
};

export const putChangePassword = async (
  json: PasswordData,
  userName: string,
): Promise<PasswordChangeResponse> => {
  return await fetchFromOldApi(
    '/form/user/' + encodeURIComponent(userName) + '/password',
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(json),
    },
  ).then((r) => r.json());
};
